export default (module, textFn, data) => {
  const items = Object.values(data)
  const result = items.map(diff(module, textFn))
  return result
}

const diff = (module, textFn) => x => {
  if (!x.deleted) {
    x.deleted = false
  }

  return {
    uuid: x.uuid,
    text: textFn(x),
    current: x.checked && module.includes(x.uuid) && !x.deleted,
    missing: (!x.checked || x.deleted) && module.includes(x.uuid),
    new: !module.includes(x.uuid) && !x.deleted && x.checked
  }
}
